import { useEffect, useRef, useState } from "react";

const stats = [
  { num: "10+", label: "年深耕東方能量文化" },
  { num: "500+", label: "件嚴選天然材質飾品" },
  { num: "1000+", label: "位有緣人的守護陪伴" },
  { num: "3", label: "個產地親赴尋源" },
];

export default function TeamValues() {
  const ref = useRef<HTMLDivElement>(null);
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => { if (entry.isIntersecting) setVisible(true); },
      { threshold: 0.2 }
    );
    if (ref.current) observer.observe(ref.current);
    return () => observer.disconnect();
  }, []);

  return (
    <section className="py-28 md:py-36 bg-[#1e1a16] relative overflow-hidden" ref={ref}>
      {/* Subtle bg */}
      <div className="absolute inset-0 opacity-5">
        <img
          src="https://readdy.ai/api/search-image?query=abstract%20oriental%20pattern%20mandala%20lotus%20texture%20dark%20background%20subtle%20decorative%20pattern%20warm%20tones&width=1920&height=800&seq=team_bg001&orientation=landscape"
          alt=""
          className="w-full h-full object-cover"
        />
      </div>

      <div className="relative z-10 max-w-7xl mx-auto px-6 md:px-16">
        {/* Stats */}
        <div
          className={`grid grid-cols-2 lg:grid-cols-4 gap-8 mb-24 transition-all duration-1000 ${
            visible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"
          }`}
        >
          {stats.map((stat, i) => (
            <div
              key={stat.label}
              className="text-center"
              style={{ transitionDelay: `${i * 100}ms` }}
            >
              <p
                className="text-[#c9a96e] font-bold mb-2"
                style={{
                  fontSize: "clamp(2rem, 4vw, 3rem)",
                  fontFamily: "'Noto Serif TC', serif",
                }}
              >
                {stat.num}
              </p>
              <p
                className="text-white/50 leading-[1.6]"
                style={{
                  fontSize: "1.1875rem",
                  fontFamily: "'Noto Serif TC', serif",
                }}
              >
                {stat.label}
              </p>
            </div>
          ))}
        </div>

        {/* Quote */}
        <div
          className={`max-w-3xl mx-auto text-center transition-all duration-1000 delay-300 ${
            visible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"
          }`}
        >
          <div className="flex items-center justify-center gap-3 mb-8">
            <span className="w-12 h-px bg-[#c9a96e]/50"></span>
            <i className="ri-double-quotes-l text-[#c9a96e] text-2xl"></i>
            <span className="w-12 h-px bg-[#c9a96e]/50"></span>
          </div>
          <blockquote
            className="text-white/80 leading-[1.75] mb-8"
            style={{
              fontSize: "clamp(1.1875rem, 2vw, 1.375rem)",
              fontFamily: "'Noto Serif TC', serif",
            }}
          >
            我們不只是在賣飾品，我們是在傳遞一份來自天地的祝福。每一件瓏靖的作品，都承載著我們對東方文化的敬意，以及對每一位有緣人最真誠的守護心意。
          </blockquote>
          <p
            className="text-[#c9a96e] font-medium text-[1rem]"
            style={{ fontFamily: "'Noto Serif TC', serif" }}
          >
            — 陳瓏靖，瓏靖手作能量創辦人
          </p>
        </div>
      </div>
    </section>
  );
}
